<section [hidden]="isSecondStep">
    <div class="container">
        <h1 class="my-5 text-primary">Cabin Search</h1>
        <div class="row">
            <div class="col-12">
                <div class="default-box p-sm-5 p-4 rounded-4">
                    @if (readyPage) {
                    <h5 class="text-primary mb-4">
                        Booking
                        {{ (cageTypeGrid?.title).replaceAll("_", " ") | titlecase }}
                    </h5>
                    <div class="bg-white rounded-4 p-4">
                        <div class="row">
                            <div class="col-xxl-7 col-md-6 cage-details order-md-1 order-2 mt-3 mt-md-0">
                                <div class="cabin-detail px-md-3">
                                    @if (cageTypeGrid?.review?.total_review > 0) {
                                    <p>
                                        <app-star-rating [maxScore]="5" [score]="cageTypeGrid?.review?.ratting"
                                            [forDisplay]="true">
                                        </app-star-rating>&nbsp;({{ cageTypeGrid?.review?.total_review }})
                                    </p>
                                    }
                                    <div class="mb-3">
                                        <div>Cage size</div>
                                        <div class="text-info fs-5">{{ cageTypeGrid?.width }} x
                                            {{ cageTypeGrid?.height }} x {{ cageTypeGrid?.length }}
                                            {{ cageTypeGrid?.unit }}</div>
                                    </div>
                                    <div class="mb-3">
                                        <div>Cage Price</div>
                                        <div class="text-info fs-5">{{ cageTypeGrid?.amount | currency }}/day</div>
                                    </div>
                                    <div class="mb-3">
                                        <div>Maximum number of pets</div>
                                        <div class="text-info fs-5">{{ cageTypeGrid?.allow_pet_number }}</div>
                                    </div>
                                    <div class="mb-md-3">
                                        <div>Price Per Extra Pet</div>
                                        <div class="text-info fs-5">
                                            @for (subPet of displayExtraPrice; track subPet;let inx= $index;let
                                            last= $last) {
                                            {{
                                            subPet.SubPetTypeTitle != null
                                            ? subPet.SubPetTypeTitle
                                            : (subPet.PetTypeTitle | titlecase)
                                            }}
                                            ({{ subPet.price | currency }}/Day)
                                            @if (!last) {
                                            <span>,</span>
                                            }
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-xxl-5 col-md-6 order-md-2 order-1">
                                <div class="pet-selection-img-box h-100 w-100 overflow-hidden rounded-4">
                                    <img [src]="filePath + 'cage/' + cageTypeGrid?.id +'/cover_image/' +cageTypeGrid?.default_cover_image"
                                        [alt]="filePath +'cage/' +cageTypeGrid?.id + '/cover_image/' +cageTypeGrid?.default_cover_image"
                                        class="h-100 w-100" />
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-12">
                <div class="default-box p-sm-5 p-4 rounded-4">
                    <div class="row">
                        <div class="col-md-6">
                            <div [hidden]="isSecondStep" class="me-4">
                                <h3 class="text-primary mb-3">Cage Booking Details</h3>
                                <p>Please select your check-in and Check-out Dates and the number of pets you would like
                                    to
                                    board,
                                    when you click check availability you will be able to select the kennel type for
                                    your
                                    booking.
                                </p>

                                <div class="my-4 pet-selection">
                                    <ng-select class="form-control  w-100 mb-2" dropdownPosition="bottom"
                                        [placeholder]="'Select Pet'" [items]="userPets" notFoundText="No Pet Exist"
                                        [searchable]="false" [multiple]="true" [clearable]="false"
                                        (add)="checkAddedPetLimit($event)" (remove)="onRemovePet($event)"
                                        bindLabel="name" bindValue="id" [selectableGroup]="true" [closeOnSelect]="false"
                                        [(ngModel)]="selectedUserPet">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            <div class="form-checkbox">
                                                <input id="item-{{ index }}" type="checkbox"
                                                    [ngModel]="item$.selected" /><span class="item-label">{{ item.name
                                                    }}</span>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <small class="d-block mt-auto">You can select multiple pets at the same
                                        time.</small>
                                </div>
                                <div>
                                    <div
                                        class="d-flex align-items-center justify-content-between flex-column flex-xl-row">
                                        <img [src]="'assets/images/boarding-services/or.svg'" alt=""
                                            class="or-img mb-3 mb-xl-0">
                                        <button class="btn btn-success" (click)="openNewPetModal()">
                                            Add New Pet
                                        </button>
                                    </div>
                                    <small class="d-block mt-2 text-xl-end text-center">Have a New Pet? Add your new pet
                                        here.</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mt-4 mt-md-0" [hidden]="isSecondStep">
                            <div class="rounded-4 bg-white shadow-sm p-4">
                                <div class="mb-4">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <span>Check - In Date</span>
                                        <span class="text-info">{{
                                            inwardDate | date : format
                                            }}</span>
                                    </div>
                                    @if (savedBookingId) {
                                    <div class="mb-3">
                                        <p-calendar [appendTo]="'body'"
                                            class="form-input form-input-with-box iconic-feild order-date-picker input-bg"
                                            placeholder="Select check-in date" [(ngModel)]="inwardDate"
                                            [ngModelOptions]="{ standalone: true }" [minDate]="minInWardDate"
                                            [maxDate]="maxDate" [dateFormat]="pCalendarDateFormat"
                                            (onSelect)="selectInwardDate()" [readonlyInput]="true"
                                            hideOnDateTimeSelect="true" [showIcon]="true" styleClass="p-calendar">
                                            <ng-template pTemplate="date" let-date>
                                                <span
                                                    [ngStyle]="{backgroundColor: getSelectedDays(date)? '#6bb9ff'  : 'inherit',color: getSelectedDays(date) ? '#ffffff' : 'inherit'}"
                                                    class="selected-inward">{{ date.day }}</span>
                                            </ng-template>
                                        </p-calendar>
                                    </div>
                                    }
                                    <div>
                                        <p-calendar [appendTo]="'body'"
                                            class="form-input form-input-with-box iconic-feild order-date-picker input-bg "
                                            [(ngModel)]="inwardTime" [ngModelOptions]="{ standalone: true }"
                                            [timeOnly]="true" [hourFormat]="12" [stepMinute]="15"
                                            (onSelect)="selectInwardTime()" [showIcon]="true" styleClass="p-calendar">
                                            <ng-template pTemplate="date" let-date>
                                                <!-- <p-header>Header</p-header> -->
                                            </ng-template>
                                            <!-- <p-header> -->
                                            <!-- </p-header> -->
                                        </p-calendar>
                                        @if (errorMessageInWardTime) {
                                        <span class="text-danger error">{{errorMessageInWardTime }}</span>
                                        }
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <span>Check - Out Date</span>
                                        <span class="text-info">{{
                                            outwardDate | date : format
                                            }}</span>
                                    </div>
                                    @if (savedBookingId) {


                                    <div class="mb-3">
                                        <p-calendar [appendTo]="'body'"
                                            class="form-input form-input-with-box iconic-feild order-date-picker input-bg"
                                            #checkout placeholder="Select check-out date" [(ngModel)]="outwardDate"
                                            [ngModelOptions]="{ standalone: true }" [minDate]="inwardDate"
                                            [dateFormat]="pCalendarDateFormat" (onSelect)="selectOutwardDate()"
                                            [readonlyInput]="true" [showIcon]="true" styleClass="p-calendar">
                                            <ng-template pTemplate="date" let-date>
                                                <span
                                                    [ngStyle]="{backgroundColor: getSelectedDays(date) ? '#6bb9ff' : 'inherit', color: getSelectedDays(date) ? '#ffffff' : 'inherit' }"
                                                    class="selected-outward">{{ date.day }}</span>
                                            </ng-template>
                                        </p-calendar>
                                    </div>
                                    }
                                    <div>
                                        <p-calendar [appendTo]="'body'"
                                            class="form-input form-input-with-box iconic-feild order-date-picker input-bg"
                                            [(ngModel)]="outwardTime" [ngModelOptions]="{ standalone: true }"
                                            [timeOnly]="true" [stepMinute]="15" [hourFormat]="12"
                                            (onSelect)="selectOutwardTime()" [showIcon]="true" styleClass="p-calendar">
                                        </p-calendar>
                                        @if (errorMessageOutWardTime) {
                                        <span class="text-danger error">{{errorMessageOutWardTime }}</span>
                                        }
                                    </div>
                                </div>
                                <div>
                                    <span>
                                        <strong>Note: </strong>Our Normal Working Hours are Monday to Friday: 06:00 AM
                                        to 08:00 PM CST, Saturday: 6:00 AM to 6:00 PM CST, Sunday: 9:00 AM - 6:00 PM
                                        CST.</span>
                                    <p class="text-danger error mb-0 mt-2">{{ errorMessage }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 addpetdetails">
                <form [formGroup]="petDetails" id="addpetdetails">
                    <div formArrayName="pets">
                        @for (pet of petDetails['controls'].pets['controls']; track
                        pet;let i = $index; let l = $last) {
                        <div [formGroupName]="i" id="added_pet_{{ i }}" class="default-box p-sm-5 p-4 rounded-4 mt-5">
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex align-items-center justify-content-between mb-3">
                                        <h5 class="text-secondary mb-0">PET 0{{i + 1}}</h5>
                                        <button type="button" class="close btn-close"
                                            (click)="cancelSelection(pet.controls.id.value, i)">
                                        </button>
                                    </div>
                                    {{ l ? moveToDiv(i) : "" }}
                                    <div class="row">
                                        <div class="col-lg-6 mb-4 mb-lg-0">
                                            <div class="inner-box shadow-sm p-4 bg-white rounded-4 inner-box h-100">
                                                <h5 class="mb-3 text-primary">Per Details</h5>
                                                <div class="row">
                                                    <div class="col-md-6 mb-3">
                                                        <span class="text-uppercase">Your Pet’s Name</span>
                                                        <h6 class="text-info">
                                                            {{ pet.controls.name.value }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <span class="text-uppercase">Sex</span>
                                                        <h6 class="text-info">
                                                            {{
                                                            pet.controls.sex.value
                                                            ? pet.controls.sex.value
                                                            : "N/A"
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <span class="text-uppercase">Color</span>
                                                        <h6 class="text-info">
                                                            {{
                                                            pet.controls.color.value
                                                            ? pet.controls.color.value
                                                            : "N/A"
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <span class="text-uppercase">Age (In Years)</span>
                                                        <h6 class="text-info">
                                                            {{
                                                            pet.controls.age.value
                                                            ? pet.controls.age.value
                                                            : "N/A"
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <span class="text-uppercase">weight(In Lbs)</span>
                                                        <h6 class="text-info">
                                                            {{
                                                            pet.controls.weight.value
                                                            ? pet.controls.weight.value
                                                            : "N/A"
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <span class="text-uppercase">Breed</span>
                                                        <h6 class="text-info">
                                                            {{
                                                            pet.controls.breed.value
                                                            ? pet.controls.breed.value
                                                            : "N/A"
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <span class="text-uppercase">Microchip</span>
                                                        <h6 class="text-info">
                                                            {{
                                                            pet.controls.microchip.value
                                                            ? pet.controls.microchip.value
                                                            : "N/A"
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <span class="text-uppercase">identification mark</span>
                                                        <h6 class="text-info">
                                                            {{
                                                            pet.controls.description.value
                                                            ? pet.controls.description.value
                                                            : "N/A"
                                                            }}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="inner-box shadow-sm p-4 bg-white rounded-4 inner-box h-100">
                                                <h5 class="mb-3 text-primary">Pet Instruction</h5>
                                                <ng-container formGroupName="pet_detail">
                                                    <div class="row">
                                                        <div class="col-12 mb-4">
                                                            <input type="text" id="feeding_instruction"
                                                                name="feeding_instruction"
                                                                formControlName="feeding_instruction" trim="blur"
                                                                class="form-control input-bg"
                                                                placeholder="Feeding Instruction" />
                                                        </div>
                                                        <div class="col-md-6 mb-4">
                                                            <input type="text" id="pet_likes" name="pet_likes"
                                                                formControlName="pet_likes" trim="blur"
                                                                class="form-control input-bg" placeholder="Pet Likes" />
                                                        </div>
                                                        <div class="col-md-6 mb-4">
                                                            <input type="text" id="pet_dis_likes" name="pet_dis_likes"
                                                                formControlName="pet_dis_likes" trim="blur"
                                                                class="form-control input-bg"
                                                                placeholder="Pet Dislikes" />
                                                        </div>
                                                        <div class="col-12 mb-4">
                                                            <input type="text" id="pet_schedule_complete_day"
                                                                name="pet_schedule_complete_day"
                                                                formControlName="pet_schedule_complete_day" trim="blur"
                                                                class="form-control input-bg"
                                                                placeholder="Pet Schedule Complete Day" />
                                                        </div>

                                                        <div class="col-md-6 mb-4 mb-md-0">
                                                            <input type="text" id="care_instruction"
                                                                name="care_instruction"
                                                                formControlName="care_instruction" trim="blur"
                                                                class="form-control input-bg"
                                                                placeholder="Care Instruction" />
                                                        </div>
                                                        <div class="col-md-6 mb-4 mb-md-0">
                                                            <input type="text" id="allergies"
                                                                formControlName="allergies" name="allergies" trim="blur"
                                                                class="form-control input-bg" placeholder="Allergies" />
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        @if (myAddons.length) {
                                        <h6 class="text-primary mt-4 mb-0">Select Add-ons</h6>
                                        <div class="row">
                                            @for (addon of pet.value.addonList; track addon;let ind =
                                            $index) {
                                            <div class="col-md-6 col-xl-4 mt-4"
                                                [ngClass]="{'plancard-selected': checkaddonIsExists( pet?.value?.addons,addon.id )}"
                                                (click)="onSelectAddon( optionModal,addon.id,addon, pet.value.id, ind, i)">
                                                <div
                                                    class="inner-box shadow-sm p-4 bg-white rounded-4 inner-box h-100 cursor-pointer">
                                                    <div class="d-flex flex-column h-100">
                                                        <div class="mb-3">
                                                            <div class="d-flex justify-content-between flex-nowrap">
                                                                <div>
                                                                    <h6 class="text-dark" [ngbTooltip]="addon?.title">
                                                                        {{ addon?.title }}
                                                                    </h6>
                                                                    @if ( addon?.showPrice && addon?.price !=
                                                                    addon?.showPrice) {
                                                                    <div class="mb-2">
                                                                        <span class="text-info mb-0 line-through">
                                                                            {{ addon?.price | currency}}/Day</span>
                                                                    </div>
                                                                    }

                                                                    <div class="mb-2">
                                                                        <span class="h6 text-info mb-0">{{
                                                                            addon?.showPrice |
                                                                            currency }}/Day</span>
                                                                    </div>
                                                                </div>
                                                                <div class="main-addon-checkbox">
                                                                    <div class="select-checkbox">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            id="addonheckbox{{ i }}_{{ ind }}"
                                                                            [checked]="checkaddonIsExists(pet?.value?.addons, addon.id)"
                                                                            (change)="onSelectAddon(optionModal,addon.id,addon,pet.value.id,ind,i);$event.stopPropagation()" />
                                                                        <label
                                                                            for="addonheckbox{{ i }}_{{ ind }}"></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="camp-plan-mid">
                                                                {{
                                                                addon?.description.length > 45
                                                                ? ( addon?.description
                                                                | slice : 0 : 99) + "..."
                                                                : addon?.description
                                                                }}
                                                                @if ( addon?.description.length > 45) {
                                                                <a href="javascript:void(0)" class="text-info link"
                                                                    (click)="$event.stopPropagation();showDescription(addon?.title,addon?.description )">
                                                                    Read More
                                                                </a>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="d-flex justify-content-between addon-show-price align-items-center mt-auto">
                                                            <div>
                                                                @if (addon?.addonCheckoutPrice) {
                                                                <span class="addon-style text-info">
                                                                    @if (addon?.addonCheckoutPrice !=
                                                                    addon?.addonCheckoutActualPrice) {
                                                                    <span class="font-size-18 line-through">
                                                                        {{addon?.addonCheckoutActualPrice | currency}}
                                                                    </span>
                                                                    }
                                                                    {{ addon?.addonCheckoutPrice | currency }}
                                                                </span>

                                                                }
                                                            </div>
                                                            @if (
                                                            (addon?.options && addon?.options.length &&addon.type ==
                                                            'custom') || (addon?.options &&addon?.options.length
                                                            &&addon.type !== 'custom') ||(addon?.options == null
                                                            &&addon.type == 'custom')
                                                            ) {
                                                            <a ngbTooltip="Select Option"
                                                                class="cursor-pointer delete-btn"
                                                                (click)="selectOptionModal(optionModal,addon,pet.value.id,i,ind,'edit');$event.stopPropagation()"
                                                                aria-hidden="true">
                                                                <img [src]="'assets/images/icon/edit.svg'" alt="">
                                                            </a>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<section [hidden]="!isSecondStep">
    <div class="container">
        <div class="order-accordion-inner mt-5">
            <div class="row">
                <div class="col-lg-5 col-12">
                    <h5 class="text-dark mb-3">Cage Summary</h5>
                    <div class="custom-summary-block box-modal">
                        <div class="pet-selection-img-box h-100 w-100 overflow-hidden rounded-4 mb-4">
                            <img [src]=" filePath + 'cage/' + cageTypeGrid?.id +'/cover_image/' +cageTypeGrid?.cover_image"
                                alt="cage-summary image" class="h-100 w-100" />
                        </div>
                        <ul class="type-list">
                            <li>
                                <div class="type-name h6">Cage Name</div>
                                <div class="type-value text-info">
                                    {{ cageTypeGrid?.title | titlecase }}
                                </div>
                            </li>
                            <li>
                                <div class="type-name h6">Check-In Date</div>
                                <div class="type-value text-info">
                                    {{ inwardDate | date : format }}
                                </div>
                            </li>
                            <li>
                                <div class="type-name h6">Check-Out Date</div>
                                <div class="type-value text-info">
                                    {{ outwardDate | date : format }}
                                </div>
                            </li>
                            <li>
                                <div class="type-name h6">Days Booked</div>
                                <div class="type-value text-info">{{ totalDays }} Day(s)</div>
                            </li>
                            <li>
                                <div class="type-name h6">Cage Price</div>
                                <div class="type-value text-info">
                                    {{ cageTypeGrid?.amount | currency }}/day
                                </div>
                            </li>
                            <li>
                                <div class="type-name h6">Price per extra pet</div>
                                <div class="type-value text-info">
                                    @for (subPet of displayExtraPrice; track subPet; let inx =
                                    $index) { @if (inx != 0) {
                                    <span>,</span>
                                    }
                                    {{
                                    subPet.SubPetTypeTitle != null
                                    ? subPet.SubPetTypeTitle
                                    : (subPet.PetTypeTitle | titlecase)
                                    }}
                                    ({{ subPet.price | currency }}/day) }
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-7 col-12 mt-lg-0 mt-4">
                    <h5 class="text-dark mb-3">Payment Summary</h5>
                    <div class="pay-block box-modal">
                        <ul class="type-list-main">
                            <li class="d-flex justify-content-between">
                                <span class="type-name">Base Amount</span>
                                <span class="type-value h6 text-primary">{{
                                    bookingDetails.cage_price | currency
                                    }}</span>
                            </li>

                            @for (pet of bookingDetails.pets; track pet;let i = $index) {
                            <ul class="multiple-type-list">
                                <li class="multi-type-title">
                                    <span class="type-name">{{ pet.name }}</span>
                                </li>

                                <li class="d-flex justify-content-between">
                                    <span class="type-name">
                                        <span class="t-name-desc">
                                            Charge for extra pet in Cage
                                        </span>
                                    </span>
                                    <span class="type-value h6 text-primary">{{ pet.extra_price | currency }}</span>
                                </li>
                            </ul>

                            @if (pet?.addon?.length) {
                            <ul class="multiple-type-list">
                                <li class="multi-type-title">
                                    <span class="type-name">Add-ons</span>
                                </li>

                                @for (addon of pet.addon; track addon; let i = $index) {
                                <li class="d-flex justify-content-between mb-2">
                                    <span class="type-name">
                                        <span class="t-name-desc">{{ addon.title }}
                                            @if (addon?.selected_option) {
                                            <span class="type-name" ngbTooltip="Selected Option">- {{
                                                addon?.selected_option
                                                }}
                                            </span>
                                            }
                                            &nbsp;&nbsp;&nbsp;&nbsp; @if (addon?.type == 'custom') {
                                            @for (addonPrice of addon?.dateWisePrice; track $index; let
                                            last = $last) {
                                            <span [ngClass]="{ 'text-info': addon?.price !== addonPrice }"
                                                class="type-name">
                                                <b> {{ addonPrice | currency }}</b>
                                                @if (!last) {
                                                <span>/ </span>
                                                }
                                            </span>
                                            } }@else {
                                            <span> <b>{{ addon?.price | currency }}</b></span>
                                            }

                                            <br />

                                            @if (addon?.type == 'custom') {
                                            (
                                            @for (date of addon.selected_dates; track $index;let last = $last) {
                                            <span [ngClass]="{'text-info': addon?.price !== date?.price}">
                                                {{ date?.date | date : "d MMM" }}
                                            </span>
                                            @if(!last){
                                            <span>
                                                <b>, </b>
                                            </span>
                                            }
                                            }
                                            )
                                            }

                                        </span>
                                    </span>
                                    <span class="type-value h6 text-primary">{{addon?.total_price | currency}}</span>
                                </li>
                                }
                            </ul>
                            } @if (pet?.products?.length > 0) {

                            <ul class="multiple-type-list">
                                <li class="multi-type-title">
                                    <span class="type-name">Mandatory Products</span>
                                </li>

                                @for (product of pet.products; track product;let i = $index) {
                                <li class="d-flex justify-content-between">
                                    <span class="type-name">
                                        <span class="t-name-desc">{{ product.title }} ({{ product.price | currency
                                            }})</span>
                                    </span>
                                    <span class="type-value h6 text-primary">{{
                                        product.price | currency
                                        }}</span>
                                </li>
                                }
                            </ul>
                            }
                            } @if (bookingDetails?.discount_detail?.rate) {

                            <li class="d-flex justify-content-between multi-type-title">
                                <span class="type-name">Applied Discount:
                                    <span class="credit-amount font-weight-bold">({{
                                        bookingDetails?.discount_detail?.title
                                        }})</span>
                                </span>
                                <span class="type-value credit-amount h6 text-primary">-{{
                                    bookingDetails?.discount_amount | currency }}</span>
                            </li>
                            }
                            <li class="d-flex justify-content-between">
                                <span class="type-name text-info fw-bold">Total Amount Due</span>
                                <span class="type-value h6 text-info fw-bold">{{
                                    bookingDetails.total | currency
                                    }}</span>
                            </li>
                        </ul>

                        <div class="advanced-form">
                            <div class="form-checkbox form-check my-3 py-3 px-sm-5">
                                <input class="form-check-input" type="checkbox" name="checkbox" id="advancePayCheckbox"
                                    [(ngModel)]="is_advance_booking_amount" />
                                <label class="form-check-label" for="advancePayCheckbox">I would like to pay in advance
                                    for this booking</label>
                            </div>
                            @if (is_advance_booking_amount) {

                            <div class="adv-form-inner card-details">
                                <div class="form-row">
                                    <div class="form-feild">
                                        <select (change)="changeCard(card)" class="form-select form-control"
                                            data-placeholder="Choose a Card" tabindex="1" [(ngModel)]="card">
                                            <option value="1">Add New Card</option>
                                            @for (card of cardList; track $index) {
                                            <option value="{{ card.id }}">
                                                {{ card?.cc_number }}
                                            </option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-feild">
                                        <input class="form-input form-control" type="number" [(ngModel)]="updatedAmount"
                                            (change)="calculateMinimumAmount(updatedAmount)" placeholder="Amount ($)" />
                                        <small class="form-control-feedback text-danger error">
                                            @if (minimumPaymentFlag) { Un-check above check-box to
                                            continue without advance payment }@else if
                                            (maximumPaymentFlag) { Advance Booking Amount should be less
                                            than or equal to Total Amount }
                                        </small>
                                    </div>
                                </div>
                                <form id="addCreditCardFormInputs" id="addCreditCardFormInputs"
                                    [formGroup]="addCreditCardForm" [hidden]="addNewCard">
                                    <div class="form-row">
                                        <div class="form-feild wbox-feild mb-3">
                                            <div class="label-moves-up">
                                                <input class="form-control" type="text" trim="blur"
                                                    style="margin-bottom: 0!important;" placeholder="Card holder name"
                                                    formControlName="cc_holder_name" id="cc_holder_name"
                                                    name="cc_holder_name" />
                                            </div>

                                            @if ( (addCreditCardForm?.controls?.cc_holder_name ?.touched
                                            || addCreditCardForm?.controls?.cc_holder_name ?.dirty ||
                                            submittedNewCard) &&
                                            !addCreditCardForm?.controls?.cc_holder_name ?.valid &&
                                            !addCreditCardForm?.controls?.cc_holder_name ?.pending ) {
                                            @if(addCreditCardForm?.controls?.cc_holder_name
                                            ?.errors.required){
                                            <span class="text-danger error">Card Holder Name is required</span>
                                            } }
                                        </div>
                                        <div class="form-feild wbox-feild mb-3">
                                            <div class="label-moves-up">
                                                <input class="form-control" style="margin-bottom: 0!important;"
                                                    type="text" trim="blur" placeholder="Card number"
                                                    formControlName="card_number" id="card_number" name="card_number"
                                                    maxlength="19" ccNumber #ccNumber="ccNumber" />
                                            </div>

                                            @if ((addCreditCardForm?.controls?.card_number ?.touched ||
                                            addCreditCardForm?.controls?.card_number ?.dirty ||
                                            submittedNewCard) &&
                                            !addCreditCardForm?.controls?.card_number ?.valid &&
                                            !addCreditCardForm?.controls?.card_number ?.pending) {
                                            <span class="text-danger error">
                                                @if(addCreditCardForm?.controls?.card_number
                                                ?.errors.required){ Card Number is required } @if
                                                (addCreditCardForm?.controls?.card_number ?.value &&
                                                addCreditCardForm?.controls?.card_number
                                                ?.errors.ccNumber) { Please Enter Valid Card Number }
                                            </span>

                                            }
                                        </div>
                                    </div>
                                    <div class="form-row form-row-sm">
                                        <div class="form-feild wbox-feild mb-3">
                                            <div class="label-moves-up">
                                                <input class="form-control" type="text" trim="blur"
                                                    style="margin-bottom: 0!important;"
                                                    placeholder="Expiry date (MM / YY)" formControlName="card_expiry"
                                                    id="card_expiry" name="card_expiry" ccExp />
                                            </div>

                                            @if((addCreditCardForm?.controls?.card_expiry ?.touched ||
                                            addCreditCardForm?.controls?.card_expiry ?.dirty ||
                                            submittedNewCard) &&
                                            !addCreditCardForm?.controls?.card_expiry ?.valid &&
                                            !addCreditCardForm?.controls?.card_expiry ?.pending){
                                            <span class="text-danger error">
                                                @if( addCreditCardForm?.controls?.card_expiry
                                                ?.errors.required) { Card Expiry Date is required } @if(
                                                addCreditCardForm?.controls?.card_expiry ?.value &&
                                                addCreditCardForm?.controls?.card_expiry ?.errors.expDate)
                                                { Please enter valid Expiry Date }
                                            </span>
                                            }
                                        </div>
                                        <div class="form-feild wbox-feild mb-3">
                                            <div class="label-moves-up">
                                                <input class="form-control" maxlength="4" type="password"
                                                    style="margin-bottom: 0!important;" placeholder="CVV"
                                                    formControlName="card_cvv" id="card_cvv" name="card_cvv" ccCVC />
                                            </div>
                                            @if ( (addCreditCardForm?.controls?.card_cvv ?.touched ||
                                            addCreditCardForm?.controls?.card_cvv ?.dirty ||
                                            submittedNewCard) && !addCreditCardForm?.controls?.card_cvv
                                            ?.valid && !addCreditCardForm?.controls?.card_cvv ?.pending
                                            ) { @if ( addCreditCardForm?.controls?.card_cvv
                                            ?.errors.minlength ) {
                                            <span class="text-danger error">Minimum 3 digits required</span>
                                            } }
                                        </div>
                                    </div>

                                    <div class="form-checkbox form-check my-3 py-3 px-sm-5">
                                        <input class="form-check-input" type="checkbox" name="save"
                                            id="saveCardCheckbox" formControlName="save" />
                                        <label class="form-check-label" for="saveCardCheckbox">Save this card for future
                                            usage</label>
                                    </div>
                                </form>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="d-flex mt-5 align-items-center justify-content-lg-end justify-content-center">
                    @if (!isSecondStep) {
                    <a [routerLink]="['/boarding-service', petTypeId]"
                        class="btn btn-outline-success me-md-4 me-2">Back</a>
                    <a (click)="onSecondStep(true)"
                        [attr.disabled]="!cageTypeGrid?.is_available_for_outpost ||!allowedNextStep || !petDetails['controls'].pets['controls'].length? true : null"
                        class="btn btn-success me-md-4 me-2"
                        [ngClass]="{disabled:!cageTypeGrid?.is_available_for_outpost || !allowedNextStep || !petDetails['controls'].pets['controls'].length ? true : null }">Save</a>
                    <a (click)="onSecondStep(false)"
                        [attr.disabled]=" !cageTypeGrid?.is_available_for_outpost ||!allowedNextStep ||!petDetails['controls'].pets['controls'].length? true : null"
                        class="btn btn-success"
                        [ngClass]="{disabled:!cageTypeGrid?.is_available_for_outpost ||!allowedNextStep ||!petDetails['controls'].pets['controls'].length ? true  : null}">Next</a>
                    }@else {
                    <a class="btn btn-outline-success me-md-4 me-2" (click)="isSecondStep = !isSecondStep">Back</a>
                    <a class="btn btn-success" (click)="bookingApply()"
                        [attr.disabled]="!cageTypeGrid?.is_available_for_outpost ||(is_advance_booking_amount && minimumPaymentFlag) ||(is_advance_booking_amount && maximumPaymentFlag)"
                        [ladda]="payment"
                        [ngClass]="{ disabled:!cageTypeGrid?.is_available_for_outpost || (is_advance_booking_amount && minimumPaymentFlag) ||(is_advance_booking_amount && maximumPaymentFlag)}">Confirm
                        Booking</a>
                    }
                </div>
                <div class="d-flex mt-5 align-items-center justify-content-lg-end justify-content-center">
                    @if (!cageTypeGrid?.is_available_for_outpost) {

                    <span class="bottom-link float-right cursor-pointer">
                        <a (click)="onSelect(cageTypeGrid, '')"><u class="fw-bold">Click Here</u></a>
                        and change Center to continue with this Cage.
                    </span>
                    }
                </div>
            </div>
        </div>
    </div>

</section>

<!-- Add New Pet Modal -->
<div class="modal new-pet-modal custom-modal" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg zoomIn animated modal-bg-blue"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-info" id="exampleModalLongTitle">Add New Pet</h5>
                <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
                    (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <div class="form-inner">
                    <form [formGroup]="newPetDetails" id="add-new-pet-form">
                        @if (!petInstructionPart) {
                        <div class="row">
                            <div class="col-md-6 mb-4" [ngClass]="{ 'form-feild-full': petSubTypeList.length == 0 }">
                                <div class="label-moves-up">
                                    <input type="text" trim="blur" id="name" name="name" [formControl]="name"
                                        placeholder="Your Pet’s Name" class="form-control" autocomplete="off" />
                                </div>
                                @if ((name?.touched || name?.dirty || newPetSubmitted) && !name?.valid &&
                                !name?.pending) {
                                @if (name?.errors.required) {
                                <span class="text-danger error">Pet's name is required</span>
                                }
                                }
                            </div>
                            @if (petSubTypeList.length>0) {
                            <div class="col-md-6 mb-4">
                                <div class="label-moves-up">
                                    <select class="form-select form-control" id="sub_pet_type_id" name="sub_pet_type_id"
                                        [formControl]="sub_pet_type_id" [(ngModel)]="defaultSubPetId">
                                        <option value="" disabled>Sub Pet Type</option>
                                        @for (subPet of petSubTypeList; track subPet; let i = $index) {
                                        <option value="{{ subPet.sub_pet_type_id }}">
                                            {{ subPet.SubPetTypeTitle }}
                                        </option>
                                        }
                                    </select>
                                </div>
                            </div>
                            }
                            <div class="col-md-6 mb-4">
                                <div class="label-moves-up">
                                    <select class="form-select form-control" id="sex" name="sex" [formControl]="sex"
                                        [ngModel]="select_sex[0]">
                                        @for (type of select_sex; track $index) {
                                        <option value="{{ type }}">{{ type | titlecase }}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="label-moves-up">
                                    <input type="text" trim="blur" id="color" name="color" [formControl]="color"
                                        placeholder="Color" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="label-moves-up">
                                    <input type="text" trim="blur" id="age" name="age" [formControl]="age"
                                        placeholder="Age (in years)" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="label-moves-up">
                                    <input type="text" trim="blur" id="weight" name="weight" [formControl]="weight"
                                        placeholder="Weight (in lbs)" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="label-moves-up">
                                    <input type="text" trim="blur" id="breed" name="breed" [formControl]="breed"
                                        placeholder="Breed" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="label-moves-up">
                                    <input type="text" trim="blur" id="microchip" name="microchip"
                                        [formControl]="microchip" placeholder="Microchip" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-12 mb-4">
                                <div class="label-moves-up">
                                    <input type="text" trim="blur" id="description" name="description"
                                        [formControl]="description" placeholder="Identification Mark"
                                        class="form-control" />
                                </div>
                            </div>
                        </div>
                        }@else {
                        <ng-container formGroupName="pet_detail">
                            <div class="row">
                                <div class="col-md-6 mb-4">
                                    <div class="label-moves-up">
                                        <input type="text" trim="blur" id="feeding_instructions"
                                            name="feeding_instructions" class="form-control"
                                            placeholder="Feeding Instruction" formControlName="feeding_instruction" />
                                    </div>
                                </div>
                                <div class="col-md-6 mb-4">
                                    <div class="label-moves-up">
                                        <input type="text" trim="blur" id="pet_schedule_complete_day1"
                                            name="pet_schedule_complete_day" class="form-control"
                                            placeholder="Pet Schedule Complete Day"
                                            formControlName="pet_schedule_complete_day" />
                                    </div>
                                </div>
                                <div class="col-md-6 mb-4">
                                    <div class="label-moves-up">
                                        <input type="text" trim="blur" id="pet_likes1" name="pet_likes"
                                            formControlName="pet_likes" placeholder="Pet Likes" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 mb-4">
                                    <div class="label-moves-up">
                                        <input type="text" trim="blur" id="pet_dislikes" name="pet_dislikes"
                                            formControlName="pet_dis_likes" placeholder="Pet Dislikes"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 mb-4">
                                    <div class="label-moves-up">
                                        <input type="text" trim="blur" id="care_instructions" name="care_instructions"
                                            formControlName="care_instruction" placeholder="Care Instruction"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 mb-4">
                                    <div class="label-moves-up">
                                        <input type="text" trim="blur" id="allergies1" name="allergies"
                                            formControlName="allergies" placeholder="Allergies" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        }
                        @if (!petInstructionPart) {
                        <button type="submit" class="btn btn-success mt-2" (click)="onPetInstruction()">
                            <span>Continue</span>
                        </button>
                        }@else {
                        <button type="button" class="btn btn-outline-success mt-2 me-2"
                            (click)="petInstructionPart = !petInstructionPart">
                            <span class="left-icon left-arrow">Back</span>
                        </button>
                        <button type="submit" class="btn btn-success mt-2" (click)="saveNewPet()">
                            <span class="left-icon save-icon">Save</span>
                        </button>
                        }

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Select new cage Modal -->
<div class="modal select-another-cage-modal custom-modal" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl zoomIn animated modal-bg-blue"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-info" id="exampleModalLongTitle">Other Cages</h5>
                <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
                    (click)="closeModal()"></button>
            </div>
            <div class="modal-body cage-modal-scrollable">
                @if (otherCages && otherCages.length) {
                <div class="row cage-listing">
                    @for (cage of otherCages; track $index) {
                    <div class="col-xl-4 col-md-6 col-12 mb-4">
                        <div class="cage-box d-flex flex-column">
                            <div>
                                <figure class="card-figure">
                                    <img class="rounded-3 img-fluid"
                                        [src]="filePath +'cage/' +cage.id + '/cover_image/' +cage?.default_cover_image"
                                        alt="" />
                                </figure>
                            </div>

                            @if (!cage?.is_available_for_outpost) {
                            <span class="bottom-link">
                                <a href="javascript:void(0)" (click)="onSelect(cage, 'other_cage')"><u
                                        class="fw-bold">Click Here</u></a>
                                and change Center to continue with this Cage.
                            </span>
                            }

                            <h6 class="card-title my-3">
                                {{ cage?.title }}
                            </h6>
                            <div class="card-price">
                                <span class="text-info h6"> {{ cage?.amount | currency }} </span>/day
                            </div>

                            <div class="mt-auto">
                                <hr />
                                <div class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
                                    <div class="size-area mb-3 mb-lg-0">
                                        Size: <span [innerHTML]="cage?.show_size"></span>
                                    </div>
                                    <div class="card-btn">
                                        <button class="btn btn-success cursor-pointer"
                                            [ngClass]="{disabled: !cage?.is_available_for_outpost}"
                                            (click)="selectOtherCage(cage);closeModal();">
                                            <span>Select</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }

                @if (!otherCages?.length) {
                <div class="col-md-12">
                    <div class="text-center">
                        <p>Oops, seems all cages are booked.</p>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>
<!--Change Booking Addon Options Modal -->

<ng-template #optionModal let-modal>
    <div class="modal-header py-0">
        <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
            (click)="closeOptionModal()"></button>
    </div>
    <div class="modal-body">
        @if(selectedAddonDetail?.options?.length){
        <h6 class="text-primary mb-2">Select Your Option</h6>
        <div class="row mb-4">
            @for (option of selectedAddonDetail?.options; track option; let ind = $index) {
            <div class="col-md-3 my-2">
                <div class="d-flex align-items-center">
                    <input class="form-check-input mt-0 me-2" type="radio" name="option_{{ ind }}" id="option_{{ ind }}"
                        [value]="option.value" (change)="changeOption($event, ind)" [checked]="option?.isChecked" />
                    <label class="form-check-label" for="option_{{ ind }}">
                        {{ option.value }}
                    </label>
                </div>
            </div>
            }
        </div>
        }

        @if (selectedAddonDetail?.type == 'custom') {
        <h6 class="text-primary mb-2">Choose Days on which you want add-ons service</h6>
        <div class="row">
            @for (date of formatDates; track date; let i = $index) {
            <div class="col-md-3 my-2">
                <div class="d-flex align-items-center p-3 rounded-4"
                    [ngStyle]="{border: date.isChecked ? '1px solid rgba(10,143,230,.5)': '1px solid rgba(10,143,230,.4)', background: date.isChecked ? '#05AAF31A' : '#FFFFFF'}">
                    <input class="form-check-input me-2 mt-0" id="date_{{ i }}" type="checkbox"
                        (change)="selectDate($event, date)" [checked]="date.isChecked" />
                    <label class="form-check-label" for="date_{{ i }}">
                        <span class="text-dark">{{ date?.date | date : "d MMM" }}</span>
                    </label>
                </div>
            </div>
            }
        </div>
        }

    </div>
    <div class="modal-footer">
        <span [ngbTooltip]="!totalDays ? 'Please select atleast one date.' : ''">
            <button class="btn btn-success" (click)="onSubmit()"
                [disabled]="!totalDays && selectedAddonDetail?.type == 'custom'" [ngClass]="{
          disabled: !totalDays && selectedAddonDetail?.type == 'custom'
        }">
                <span>Submit</span>
            </button>
        </span>
    </div>
</ng-template>